import { render, staticRenderFns } from "./FinalEvaluationData.vue?vue&type=template&id=3b5f54e4&scoped=true&"
import script from "./FinalEvaluationData.vue?vue&type=script&lang=js&"
export * from "./FinalEvaluationData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5f54e4",
  null
  
)

export default component.exports